import { Validatable } from "@/core/models";
import moment from "moment";

export class VueUserContextModel {
  timestamp: string;
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  roleId: number;
  roleName: string;
  /**
   * Is this generally an admin role? (IMI, EI, Dovetail)
   */
  isAdmin: boolean;
  isUser: boolean;
  isDovetail: boolean;
  isImi: boolean;
  isEi: boolean;

  constructor(data?: Partial<VueUserContextModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class UserCollectionModel {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  emailConfirmed: boolean;
  roles: string[];
}

export class RoleModel {
  id: number;
  name: string;
}

export class UserAccountModel extends Validatable {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  fullName: string;
  // NOTE: Change to roleIds at some point if we start
  // allowing users to be in multiple roles
  roleId: number;
}

export class WorkshopUserModel {
  fullName: string;
  companyName: string;
  workshopDate: moment.Moment;
  workshopCountyName: string;
}

export class UserSearchModel {
  userId?: number;
  fullName: string;
  email: string;
}

export class AttendeeModel {
  attendeeName: string;
  attendeeEmail: string;
}

export class EvaluationLoginModel extends Validatable {
  /** User's email. */
  email: string;

  /** User's password. */
  password: string;
}
